import { Component, OnInit } from '@angular/core';
import { ChangePasswordParameters } from 'src/app/models/ui/ChangePasswordParameters';
import notify from 'devextreme/ui/notify';
import { UserService } from 'src/app/services/user.service';
import { HelperService } from 'src/app/services/Helper/helper.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  isAuthorized: string;
  isExpiring: string;
  
  ngOnInit() {
    this.isAuthorized = localStorage.getItem("isAuthorized");
    this.isExpiring = localStorage.getItem("isExpiring");

    if(this.isAuthorized === "true" || this.isExpiring === "true") {
      this.helper.setTitle("Provider - Change Password");
    }
    else
    location.assign("#/login-form");
  }
  
  changePasswordParameters: ChangePasswordParameters;

  constructor(private userService: UserService, private helper: HelperService) {  
    this.changePasswordParameters = new ChangePasswordParameters();
  }

  submitChanges(e) {
    this.changePasswordParameters.UserName = localStorage.getItem("ProviderCurrentUsername");
    if(this.changePasswordParameters.NewPassword === this.changePasswordParameters.ConfirmPassword) {
      this.userService.changePassword(this.changePasswordParameters).subscribe(data => this.displayResult(data));
    }
    else
      notify("Please provide matching entries for new and confirm password");
  }

  displayResult(data) {
    alert(data);
    localStorage.removeItem("isExpired");
  }
}